<template lang="pug">
  div(:style="'min-height:'+h")
    div.px-0.white.detail-head.head-border
      el-row.pl-5
        el-col(:span="8")
          Breadcrumb
    div(style="height:70px")
    el-main.white.pa-3.ma-4
      el-row.py-3(type="flex" justify="center")
        el-col(:span="22")
            el-row(type="flex" justify="start" :gutter="10")
              el-col(:span="6")
                el-select.w-100(v-model="list.purchase_org" clearable filterable placeholder="采购组织")
                  el-option(v-for="item in buyorg" :key="item.pk_org" :label="item.name" :value="item.pk_org")
              el-col(:span="6")
                el-select.w-100(v-model="list.pk_supplier" filterable remote placeholder="请搜索供应商" :remote-method="getSupplyList" :loading="loadingSupply" clearable)
                  el-option(v-for="item in supply" :key="item.pk_supplier" :label="item.name" :value="item.pk_supplier")
              el-col(:span="6")
                el-input.w-100(v-model="list.ct_code" placeholder="合同号" clearable)   
              el-col(:span="6")
                el-input.w-100(v-model="list.ct_name" placeholder="合同名称" clearable)   
      el-row.py-3(type="flex" justify="center")
          el-col(:span="22")
            el-row(type="flex" justify="start" :gutter="10")        
              el-col(:span="6")
                el-input.w-100(v-model="list.content" placeholder="说明" clearable)   
              el-col(:span="6")
                el-select.w-100(v-model="list.if_create" filterable placeholder="是否生成" clearable)
                  el-option(label="是" value="Y")
                  el-option(label="否" value="N")     
              el-col(:span="6")
                el-button(type="primary" @click="search" :loading="loading") 查询
                el-button(@click="clear") 清空
      el-table(:data="data" v-loading="loading" size="mini")
        el-table-column(prop="purchase_org_name" label="采购组织" min-width="120" show-overflow-tooltip)
        el-table-column(prop="pk_supplier_name" label="供应商" min-width="120" show-overflow-tooltip)
        el-table-column(prop="buyer_code_name" label="采购员")
        el-table-column(prop="ct_pu_code" label="合同号" min-width="120" show-overflow-tooltip)
        el-table-column(prop="ct_pu_name" label="合同名称" min-width="150" show-overflow-tooltip)
        el-table-column(prop="effective_date" label="付款日期" min-width="100")
        el-table-column(prop="money_dh" label="电汇金额")
        el-table-column(prop="money_cd" label="承兑金额" min-width="100")
        el-table-column(prop="money" label="总金额" min-width="100")
        el-table-column(prop="source" label="来源")
        el-table-column(prop="content" label="说明" min-width="180" show-overflow-tooltip)
        el-table-column(prop="if_create" label="是否生成" :formatter="sfktFormate")
        el-table-column(label="操作" width="150")
          template(slot-scope="scope")
            el-button(size="mini" type="primary" plain v-show="scope.row.if_create == 'N'" @click="generate(scope.row)") 生成
            el-button(size="mini" type="danger" plain v-show="scope.row.if_create == 'N'" @click="del(scope.row)") 删除
      el-pagination.my-4.text-center(@size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="list.page_num" :page-sizes="page_sizes" :page-size="list.page_size" layout="total, sizes, prev, pager, next, jumper" :total="count" background)
</template>
<script>
export default {
  data() {
    return {
      h: "",
      loading: false,
      data: [],
      count: 0,
      list: {
        page_num: 1,
        page_size: 10,
        purchase_org: null,
        pk_supplier: null,
        ct_code: null,
        ct_name: null,
        content: null,
        if_create: 'N',
      },
      supply: [],
      loadingSupply: false,
    };
  },
  methods: {
    clear () {
      this.list.purchase_org =null;
      this.list.pk_supplier =null;
      this.list.ct_code =null;
      this.list.ct_name =null;
      this.list.content =null;
      this.list.if_create =null;
    },
    search() {
      this.list.page_num = 1;
      this.$router.push({
        path: this.$route.path,
        hash: this.$route.hash,
        query: this.list,
      });
    },
    handleSizeChange(e) {
      this.list.page_size = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    handleCurrentChange(e) {
      this.list.page_num = e;
      this.$router.push({
        path: this.$route.path,
        query: this.list,
      });
    },
    async getList() {
      this.loading = true;
      let res = await this.$api.purchase_payment.getWarehouseList(this.list);
      this.loading = false;
      if (res) {
        this.data = res.data;
        this.count = res.count;
      }
    },
    del(e) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = [];
          data.push({
            ts: e.ts,
            id: e.id,
          });
          let res = await this.$api.purchase_payment.delWarehouse(data);
          if (res) {
            this.$notify({
              message: "操作成功",
              type: "success",
            });
            this.getList();
          }
        })
        .catch(() => {});
    },
    async getSupplyList(query) {
      if (!query) {
        return false;
      }
      localStorage.setItem("PurchaseContract_query", query);
      this.loadingSupply = true;
      let res = await this.$api.supplier.getotherList({
        key_name: query,
        page_num: 1,
        page_size: 100,
        no_check: 1,
        checkstatus: 3,
      });
      this.loadingSupply = false;
      if (res) {
        this.supply = res.data;
      }
    },
    async generate(e) {
      let data = [];
      data.push({
        buyer_code_name: e.buyer_code_name,
        content: e.content,
        content_hidden: JSON.parse(e.content_hidden),
        ct_pu_code: e.ct_pu_code,
        ct_pu_name: e.ct_pu_name,
        effective_date: e.effective_date,
        ts: e.ts,
        id: e.id,
        if_create: 'Y',
        money: e.money,
        money_cd: e.money_cd,
        money_dh: e.money_dh,
        pk_supplier_name: e.pk_supplier_name,
        purchase_org_name: e.purchase_org_name,
        source: e.source,
      });
      let res = await this.$api.purchase_payment.generateWarehouse(data);
      if (res) {
        this.$notify({
          message: "操作成功",
          type: "success",
        });
        this.getList();
      }
    },
    init() {
      let data = this.$route.query;
      if (JSON.stringify(data) != "{}") {
        this.list = this.$utils.cloneDeep(data);
        if (data.page_num) {
          this.list.page_num = parseInt(data.page_num);
        }
        if (data.page_size) {
          this.list.page_size =
            this.page_sizes.indexOf(parseInt(data.page_size)) > -1
              ? parseInt(data.page_size)
              : this.page_sizes[0];
        }
      }
      this.getList();
    },
    sfktFormate(row){
      if (row.if_create == 'Y' ){
        return "是";
      } else {
        return "否";
      }
    }
  },
  mounted() {
    this.h = document.body.clientHeight - 61 + "px";
  },
  created () {
    this.getPurchaseSelfOrg();
    if (this.$store.state.token && this.$store.state.stock_org == false)
      this.getStockOrg();
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true,
    },
  },
};
</script>